const DeliveredIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill="#EEF2FF" />

      <rect x="14" y="18" width="18" height="12" rx="2.5" fill="#1E1B6A" />

      <path
        d="M14 19L23 25L32 19"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <circle cx="32" cy="28" r="5" fill="#1E1B6A" />

      <path
        d="M30.5 28L31.8 29.3L33.8 27.3"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeliveredIcon;
